// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"fae4e569","461":"166e5518","830":"5c62ea92"}[chunkId] + ".css";
};